
import React from 'react'
import "../Styles/Item.css"
import { motion } from "framer-motion"
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { setActive, getActive } from "../Utility/AsyncStorageData"

function Item({ icon, name, path }) {
    
  let navigate = useNavigate();
  var active = getActive();
    const iconName = {
        true: {
            opacity: 1
        },
        false: {
            opacity: 0,
            display: "none",
        }
    }
    return (
        <div className='item'  onClick={()=>{navigate(`${path}`); setActive(JSON.stringify(name));}} 
        style={{backgroundColor: (name == active  ? "white" : "none"), borderRadius: '12px'}}
        >
            <div className='icon'  
            style={{color: (name == active  ? "black" : "none")}} 
            >
                {icon}
            </div>
            <motion.span 
                variants={iconName}>
                <Link to = {path} 
                style={{color: (name == active  ? "black" : "none")}} 
                >
                    {name}
                </Link>
            </motion.span>
        </div>
    )
}

export default Item